<template>
  <div class="ege-page">
    <lazy-hydrate when-visible>
      <ege-banner
        :modal-type="egeModalTypeForStatic"
        :min-title="getMinTitleForBanner"
        :banner-title="getTitleForBanner"
        @openModal="openEgeModal"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ege-city
        v-if="isCityPage"
        @openModal="openEgeModal()"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <div
        v-if="showKursIncludesAfterBanner"
        class="v2-container-small"
      >
        <kurs-includes />
      </div>
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <formats-education v-if="isCityPage ? isMoscowPage : true" />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <section class="ege-page__prepare-score">
        <exam-preparing />

        <high-scores
          type="ege"
          @openModal="openEgeModal"
          @openRegModal="openRegModal"
          @openStrategyModal="openStrategyModal"
        />
      </section>
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ege-oge-program v-if="isSubpage" />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <course-tutor
        v-if="isSubpage"
        @openModal="openEgeModal"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <exam-best v-if="!isSubpage" />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <exam-tutors
        v-if="!isSubpage"
        :title="tutorsTitle"
        @openModal="openEgeModal"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <exam-pluses />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <exam-schedule
        :page-type="'ege'"
        @openModal="openEgeModal"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <div
        v-if="showKursIncludesAfterSchedule"
        class="v2-container-small"
      >
        <kurs-includes />
      </div>
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <working-official-new />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <student-results-new />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <know-how-to-teach-new />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <school-news-and-events />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <faq-accordion-new
        page="ege"
        sticker-url="/v2/ege/faq/star-sticker.png"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <exam-form />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <exam-packages @openModal="openEgeModal" />
    </lazy-hydrate>

    <exam-form-modal
      v-if="showEgeModal"
      :modal-type="egeModalType"
      :modal-title="egeModalTitle"
      @closeModal="closeEgeModal"
    />

    <exam-reg-modal
      v-if="showRegModal"
      :modal-type="regModalType"
      @closeModal="closeRegModal"
    />

    <ege-strategy-modal
      v-if="showStrategyModal"
      :modal-type="strategyModalType"
      @closeModal="closeStrategyModal"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import scrollParallax from '@/utils/scrollParallax';
import HeadMixin from '@/mixins/HeadMixin';
import { SUBJECTS } from '@/data/constants';

import LazyHydrate from 'vue-lazy-hydration';
import EgeBanner from '@/components/v2/ege/EgeBanner.vue';
import EgeStrategyModal from '@/components/v2/ege/EgeStrategyModal.vue';
import ExamBest from '@/components/v2/ege/ExamBest.vue';
import ExamForm from '@/components/v2/ege/ExamForm.vue';
import ExamFormModal from '~/components/v2/ege/ExamFormModal.vue';
import ExamPackages from '@/components/v2/ege/ExamPackages.vue';
import ExamPluses from '@/components/v2/ege/ExamPluses.vue';
import ExamPreparing from '@/components/v2/ege/ExamPreparing.vue';
import ExamRegModal from '@/components/v2/ege/ExamRegModal.vue';
import ExamSchedule from '~/components/v2/ege/ExamSchedule.vue';
import ExamTutors from '@/components/v2/ege/ExamTutors.vue';
import FaqAccordionNew from '@/components/v2/common/FaqAccordion/FaqAccordionNew.vue';
import HighScores from '@/components/v2/ege/HighScores/HighScores.vue';
import KnowHowToTeachNew from '@/components/v2/ege/KnowHowToTeachNew.vue';
import StudentResultsNew from '@/components/v2/ege/StudentResultsNew.vue';
import WorkingOfficialNew from '@/components/v2/ege/WorkingOfficialNew.vue';
import EgeOgeProgram from '@/components/v2/ege/program/EgeOgeProgram.vue';
import CourseTutor from '@/components/v2/ege/CourseTutor/CourseTutor.vue';
import SchoolNewsAndEvents from '@/components/v2/ege/SchoolNewsAndEvents.vue';
import KursIncludes from '@/components/v2/kurs/KursIncludes.vue';
import EgeCity from '@/components/v2/ege/EgeCity.vue';
import FormatsEducation from '~/components/v2/ege/FormatsEducation.vue';

export default {
  name: 'EgeOldPage',
  components: {
    FormatsEducation,
    EgeCity,
    LazyHydrate,
    EgeBanner,
    EgeStrategyModal,
    ExamBest,
    ExamForm,
    ExamFormModal,
    ExamPackages,
    ExamPluses,
    ExamPreparing,
    ExamRegModal,
    ExamSchedule,
    ExamTutors,
    FaqAccordionNew,
    HighScores,
    KnowHowToTeachNew,
    StudentResultsNew,
    WorkingOfficialNew,
    EgeOgeProgram,
    CourseTutor,
    SchoolNewsAndEvents,
    KursIncludes,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',
  scrollToTop: true,

  data: () => ({
    // для head
    image: '/v2/ege/share-image-ege.jpg',
    headScripts: [{
      // eslint-disable-next-line max-len,vue/max-len
      src: 'https://js.onef.pro/static/reg1f_v1.js?1f_pixel_id=24aed672-c5f3-4e78-ba7e-eed74b860cd1&event_type=visit&product=new_online_school_ege',
      defer: true,
      type: 'text/javascript',
    }],

    showEgeModal: false,
    egeModalType: null,
    egeModalTitle: null,

    showRegModal: false,
    regModalType: null,

    showStrategyModal: false,
    strategyModalType: null,
  }),
  computed: {
    ...mapGetters({
      isTablet: 'isTablet',
    }),
    tutorsTitle() {
      if (this.isTablet) {
        return '<span><span>Качественные знания</span></span><br>от лучших преподавателей';
      }
      return 'Доверьте свое обучение<br><span><span>профессионалам</span></span>';
    },
    getMinTitleForBanner() {
      const pageName = this.$route?.params?.subpage;

      // eslint-disable-next-line default-case
      switch (pageName) {
        case SUBJECTS.matematika:
          return 'Подготовка к ЕГЭ по базовой математике';
        case SUBJECTS.matematikaProfil:
          return 'Подготовка к ЕГЭ по профильной математике';
        case SUBJECTS.russkijYazyk:
          return 'Подготовка к ЕГЭ по русскому языку';
        case SUBJECTS.literatura:
          return 'Подготовка к ЕГЭ по литературе';
        case SUBJECTS.anglijskijYazyk:
          return 'Подготовка к ЕГЭ по английскому языку';
        case SUBJECTS.informatika:
          return 'Подготовка к ЕГЭ по информатике';
        case SUBJECTS.obshchestvoznanie:
          return 'Подготовка к ЕГЭ по обществознанию';
        case SUBJECTS.istoriya:
          return 'Подготовка к ЕГЭ по истории';
        case SUBJECTS.fizika:
          return 'Подготовка к ЕГЭ по физике';
        case SUBJECTS.himiya:
          return 'Подготовка к ЕГЭ по химии';
        case SUBJECTS.biologiya:
          return 'Подготовка к ЕГЭ по биологии';
      }

      if (this.isCityPage) {
        return `Курсы подготовки к ЕГЭ в ${this.cityPageName}`;
      }

      return 'Курсы подготовки к ЕГЭ';
    },
    getTitleForBanner() {
      const pageName = this.$route?.params?.subpage;

      switch (pageName) {
        case SUBJECTS.matematika:
          return 'Сдай ЕГЭ 2025 по базовой математике <br><span><span>на «отлично»</span></span>';
        case SUBJECTS.matematikaProfil:
          return 'Сдай ЕГЭ 2025 по <br>профильной математике <br><span><span>на «отлично»</span></span>';
        case SUBJECTS.russkijYazyk:
          return 'Сдай ЕГЭ 2025 по <br>русскому языку <br><span><span>на «отлично»</span></span>';
        case SUBJECTS.literatura:
          return 'Сдай ЕГЭ 2025 по <br>литературе <br><span><span>на «отлично»</span></span>';
        case SUBJECTS.anglijskijYazyk:
          return 'Сдай ЕГЭ 2025 по <br>английскому языку <br><span><span>на «отлично»</span></span>';
        case SUBJECTS.informatika:
          return 'Сдай ЕГЭ 2025 по <br>информатике <br><span><span>на «отлично»</span></span>';
        case SUBJECTS.obshchestvoznanie:
          return 'Сдай ЕГЭ 2025 по <br>обществознанию <br><span><span>на «отлично»</span></span>';
        case SUBJECTS.istoriya:
          return 'Сдай ЕГЭ 2025 по истории <br><span><span>на «отлично»</span></span>';
        case SUBJECTS.fizika:
          return 'Сдай ЕГЭ 2025 по физике <br><span><span>на «отлично»</span></span>';
        case SUBJECTS.himiya:
          return 'Сдай ЕГЭ 2025 по химии <br><span><span>на «отлично»</span></span>';
        case SUBJECTS.biologiya:
          return 'Сдай ЕГЭ 2025 по <br>биологии <br><span><span>на «отлично»</span></span>';
        default:
          return 'Подготовим к ЕГЭ<br> <span><span>с любого уровня</span></span><br> до результата';
      }
    },
    egeModalTypeForStatic() {
      const pageName = this.$route?.params?.subpage;

      switch (pageName) {
        case SUBJECTS.matematika:
          return 'math';
        case SUBJECTS.matematikaProfil:
          return 'math';
        case SUBJECTS.russkijYazyk:
          return 'russian';
        case SUBJECTS.anglijskijYazyk:
          return 'english';
        case SUBJECTS.informatika:
          return 'informatics';
        case SUBJECTS.obshchestvoznanie:
          return 'social';
        case SUBJECTS.istoriya:
          return 'history';
        case SUBJECTS.fizika:
          return 'physics';
        case SUBJECTS.himiya:
          return 'chemistry';
        case SUBJECTS.biologiya:
          return 'biology';
        case SUBJECTS.literatura:
          return 'literature';
        default:
          return 'demo';
      }
    },

    showKursIncludesAfterBanner() {
      const routeNameCondition = this.$route.name === 'ege';

      const paramsCondition = this.$route.name === 'ege-subpage' && [
        'matematika-profil',
        'matematika',
        'russkij-yazyk',
      ].includes(this.$route.params?.subpage);

      return routeNameCondition || paramsCondition;
    },
    showKursIncludesAfterSchedule() {
      return this.$route.name === 'ege-subpage' && [
        'anglijskij-yazyk',
        'informatika',
        'istoriya',
        'obshchestvoznanie',
        'biologiya',
        'fizika',
        'himiya',
        'literatura',
      ].includes(this.$route.params?.subpage);
    },

    isSubpage() {
      return this.$route.name === 'ege-subpage';
    },
    isCityPage() {
      return [
        'ege-moscow',
        'ege-chelyabinsk',
        'ege-kazan',
        'ege-krasnoyarsk',
        'ege-nizhny-novgorod',
        'ege-novosibirsk',
        'ege-saint-petersburg',
        'ege-samara',
        'ege-ufa',
        'ege-yekaterinburg',
      ].includes(this.$route.name);
    },
    isMoscowPage() {
      return this.$route.name === 'ege-moscow';
    },
    cityPageName() {
      switch (this.$route.name) {
        case 'ege-moscow': return 'Москве и МО';
        case 'ege-chelyabinsk': return 'Челябинске';
        case 'ege-kazan': return 'Казани';
        case 'ege-krasnoyarsk': return 'Красноярске';
        case 'ege-nizhny-novgorod': return 'Нижнем Новгороде';
        case 'ege-novosibirsk': return 'Новосибирске';
        case 'ege-saint-petersburg': return 'Санкт-Петербурге';
        case 'ege-samara': return 'Самаре';
        case 'ege-ufa': return 'Уфе';
        case 'ege-yekaterinburg': return 'Екатеринбурге';
        default: return '';
      }
    },

    /**
     * для head
     */
    title() {
      if (this.isCityPage) {
        return `Курсы подготовки к ЕГЭ 2025 в онлайн-школе «Синергия» в ${this.cityPageName}`;
      }

      const pageName = this.$route?.params?.subpage;

      switch (pageName) {
        case SUBJECTS.matematika:
          return 'Курсы подготовки к ЕГЭ 2025 по математике в онлайн-школе «Синергия»';
        case SUBJECTS.matematikaProfil:
          return 'Курсы подготовки к ЕГЭ 2025 по профильной математике в онлайн-школе «Синергия»';
        case SUBJECTS.russkijYazyk:
          return 'Курсы подготовки к ЕГЭ 2025 по русскому языку в онлайн-школе «Синергия» ';
        case SUBJECTS.literatura:
          return 'Курсы подготовки к ЕГЭ 2025 по литературе в онлайн-школе «Синергия» ';
        case SUBJECTS.anglijskijYazyk:
          return 'Курсы подготовки к ЕГЭ 2025 по английскому языку в онлайн-школе «Синергия» ';
        case SUBJECTS.informatika:
          return 'Курсы подготовки к ЕГЭ 2025 по информатике в онлайн-школе «Синергия» ';
        case SUBJECTS.obshchestvoznanie:
          return 'Курсы подготовки к ЕГЭ 2025 по обществознанию в онлайн-школе «Синергия»';
        case SUBJECTS.istoriya:
          return 'Курсы подготовки к ЕГЭ 2025 по истории в онлайн-школе «Синергия»';
        case SUBJECTS.fizika:
          return 'Курсы подготовки к ЕГЭ 2025 по физике в онлайн-школе «Синергия»';
        case SUBJECTS.himiya:
          return 'Курсы подготовки к ЕГЭ 2025 по химии в онлайн-школе «Синергия»';
        case SUBJECTS.biologiya:
          return 'Курсы подготовки к ЕГЭ 2025 по биологии в онлайн-школе «Синергия»';
        default:
          return 'Курсы подготовки к ЕГЭ 2025 в онлайн-школе «Синергия»';
      }
    },
    description() {
      if (this.isCityPage) {
        // eslint-disable-next-line max-len,vue/max-len
        return `Курсы подготовки к ЕГЭ 2025 в ${this.cityPageName} по всем предметам в онлайн-школе Синергия. Занимайся очно в своем городе и онлайн. Готовься с преподавателями из ведущих вузов России`;
      }

      // eslint-disable-next-line max-len,vue/max-len
      return 'Подготовься к ЕГЭ по математике, русскому языку, обществознанию, биологии и другим предметам. Удобный формат, опытные преподаватели, профориентация и бесплатное пробное занятие';
    },
    canonical() {
      return !this.$route?.params?.subpage;
    },
    canonicalHref() {
      if (this.canonical) {
        return false;
      }
      return 'https://school.synergy.ru/ege';
    },
    alternateHref() {
      if (this.canonical) {
        return false;
      }
      return `https://school.synergy.ru/ege/${this.$route?.params?.subpage}`;
    },
  },

  mounted() {
    this.setAnimationStyles();
    window.addEventListener('scroll', this.setAnimationStyles);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setAnimationStyles);
  },

  methods: {
    setAnimationStyles() {
      const parallaxElements = [
        { id: 'woSticker', style: 'translateY', slow: 5 },
        { id: 'srSticker', style: 'translateY', slow: 5 },
        { id: 'faqSticker', style: 'translateY', slow: 5 },
        { id: 'formSticker', style: 'translateY', slow: 5 },
      ];

      if (!this.isSubpage) {
        parallaxElements.push({ id: 'tutorsHeartIcon', style: 'translateY', slow: 5 });
      }

      scrollParallax(parallaxElements);
    },
    openEgeModal(modalType = 'base', modalTitle = null) {
      this.egeModalType = modalType;
      this.egeModalTitle = modalTitle;
      this.showEgeModal = true;
    },
    closeEgeModal() {
      this.showEgeModal = false;
      this.egeModalType = null;
    },
    openRegModal(modalType) {
      this.regModalType = modalType;
      this.showRegModal = true;
    },
    closeRegModal() {
      this.showRegModal = false;
      this.regModalType = null;
    },
    openStrategyModal(modalType) {
      this.strategyModalType = modalType;
      this.showStrategyModal = true;
    },
    closeStrategyModal() {
      this.showStrategyModal = false;
      this.strategyModalType = null;
    },
  },
};
</script>

<style scoped lang="scss">
.ege-page {
  display: flex;
  flex-direction: column;
  gap: 200px;
  padding-bottom: 140px;

  background-color: $gray-bg;

  @include media-down(laptop) {
    gap: 160px;
    padding-bottom: 120px;
  }

  @include media-down(tablet) {
    gap: 120px;
    padding-bottom: 56px;
  }

  .ege-page__prepare-score {
    display: grid;
    gap: 100px;

    @include media-down(tablet) {
      gap: 96px;
    }
  }

  ::v-deep .faq {
    &__sticker {
      width: 110px;
      right: -59px;
      top: 100px;
      z-index: 1;

      @media (max-width: 1350px) {
        width: 90px;
        right: -10px;
      }

      @include media-down(tablet) {
        width: 55px;
        right: -5px;
      }
    }
  }
}
</style>
